<!-- ✅ Unified Modal Structure -->
<div class="custom-modal" *ngIf="currentStep === 1 || currentStep === 2">
  <div class="custom-overlay">

    <!-- ✅ Step 1 Content -->
    <div class="info-card text-center position-relative" *ngIf="currentStep === 1">
      <div class="modal-text-container mx-auto text-center">
        <div class="report-modal-title mb-3">
          We'd love your input if anything seems suspicious or incorrect.
        </div>
        <p class="report-modal-desc mb-4">
          Did something seem off with this property? You can report issues to help us maintain a safe and trusted
          platform.
        </p>
      </div>

      <div class="d-flex justify-content-center gap-3">
        <button class="btn cancel-btn px-4 py-2" (click)="cancelModal()">Cancel</button>
        <button class="btn report-list-btn px-4 py-2" (click)="goToStep(2)">Report This Listing</button>
      </div>
    </div>

    <!-- ✅ Step 2 Content -->
    <div class="info-card-step2 text-center position-relative" *ngIf="currentStep === 2">
      <div class="modal-text-container mx-auto mb-4 text-center report-step2-container">
        <div class="report-modal-title mb-4">Provide more details about the issue.</div>

        <div class="report-checkbox-group mb-3 text-start">
          <label class="report-label">What details were not correct?</label>
          <div class="report-checkbox-list">
            <label class="report-checkbox" *ngFor="let issue of issueOptions">
              <input type="checkbox" [checked]="selectedIssues.includes(issue)" (change)="onCheckboxChange($event, issue)">
              {{ issue }}
            </label>
          </div>
        </div>

        <textarea
          class="report-message-box mb-3"
          placeholder="Describe the problem in detail..."
          rows="3"
          maxlength="250"
          [(ngModel)]="comment"
        ></textarea>

        <div class="report-input-row mb-4" *ngIf="!isLoggedIn">
          <input type="text" class="report-input" placeholder="Your Name" [(ngModel)]="name">
          <input type="text" class="report-input" placeholder="Contact Number" [(ngModel)]="contact">
        </div>
      </div>

      <div class="report-btn-group d-flex justify-content-center gap-3 mb-2">
        <button class="btn cancel-btn px-4 py-2" (click)="cancelModal()">Cancel</button>
        <button class="btn report-submit-btn px-4 py-2" (click)="reportListing()">Submit Report</button>
      </div>
    </div>

  </div>
</div>
